/* eslint-disable import/prefer-default-export */
import { useQueryClient } from '@tanstack/react-query';
import { EnochQueryKeys } from 'query/enoch';
import { useCallback } from 'react';
import { SOCKET_EVENTS, useSubscriber } from 'socket/useSubscriber';
import { ENOCH_MACHINE_STATE } from './enoch-config.helpers';

export const useEnochState = () => {
  const queryClient = useQueryClient();

  const updateState = useCallback(
    data => {
      try {
        function addIpToList(queryKey, ip) {
          queryClient.setQueryData([queryKey], oldData => {
            if (!oldData) return [ip];
            return Array.from(new Set([...oldData, ip]));
          });
        }

        function removeIpFromList(queryKey, ip) {
          queryClient.setQueryData([queryKey], oldData => {
            if (!oldData) return oldData;
            return oldData.filter(v => v !== ip);
          });
        }

        if (data.userDataDir) {
          switch (data.state) {
            case ENOCH_MACHINE_STATE.IDLE:
              addIpToList(EnochQueryKeys.allIdleEnochVMs, data.ip);
              removeIpFromList(EnochQueryKeys.allRunningEnochVMs, data.ip);
              break;
            case ENOCH_MACHINE_STATE.RUNNING:
            case ENOCH_MACHINE_STATE.SCHEDULED:
              addIpToList(EnochQueryKeys.allRunningEnochVMs, data.ip);
              removeIpFromList(EnochQueryKeys.allIdleEnochVMs, data.ip);
              break;
            case ENOCH_MACHINE_STATE.DISCONNECTED:
              removeIpFromList(EnochQueryKeys.allIdleEnochVMs, data.ip);
              removeIpFromList(EnochQueryKeys.allRunningEnochVMs, data.ip);
              break;
          }
        }

        queryClient.setQueryData(
          [EnochQueryKeys.enochConfig, { ipAddress: data.ip }],
          oldData => {
            if (!oldData) return oldData;
            return {
              ...oldData,
              state: data.state,
            };
          },
        );
      } catch (e) {}
    },
    [queryClient],
  );

  useSubscriber(SOCKET_EVENTS.ENOCH.MACHINE_STATE, updateState);
};
